const tech_img = require('../../assets/img/tutorials/urbanos/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/urbanos/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/urbanos/func.png');
const secondary_func_img = require('../../assets/img/tutorials/urbanos/secondary-func.png');

export const UrbanosSteps = [
    {
        name: 'Espacio Urbano Inteligente',
        title: 'Descripción funcional',
        description: <span>
            <p>Este <b>Espacio Urbano Inteligente (EUI) muestra las aplicaciones y posibilidades tecnología IoT en una ciudad</b>. Permite la interacción ciudadana con diversas aplicaciones de IoT, abordando la necesidad de interoperabilidad entre diferentes Áreas Municipales. El EUI integra sensores y dispositivos conectados que recopilan datos en tiempo real para mejorar la gestión de servicios urbanos como iluminación, seguridad y tráfico
</p>
            <p>El objetivo es enriquecer la experiencia ciudadana con los servicios municipales y proporcionar una visión anticipada de las posibilidades futuras de la ciudad. La integración de tecnologías avanzadas busca optimizar la calidad de vida urbana, asegurar una gestión más eficaz de los recursos y fomentar la participación ciudadana en la evolución de su entorno


            </p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Cultura, Turismo y Deporte</p>
            <p>Área de Gobierno de Urbanismo, Medio Ambiente y Movilidad</p>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Espacio Urbano Inteligente',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Renderizado Inmersivo</b> que ofrece visualizaciones realistas y en tiempo real, mejorando la experiencia de usuario y la comprensión del espacio físico.</li>
                    <li><b>Integración de Dispositivos IoT</b> para la recopilación continua de datos del entorno, que soportan la infraestructura de la ciudad inteligente y la conectividad.</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                    <li><b>Síntesis de Datos por IoT / IA</b>: Compilación y análisis de datos recogidos por sensores y dispositivos inteligentes, proporcionando una visión holística y actualizada del comportamiento y las necesidades de la ciudad.
</li>
                </ul>
            </span>


        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];